import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { TranslatePipe } from './translate.pipe';
@NgModule({
  imports:[
    CommonModule
  ],
  declarations: [TranslatePipe],
  providers: [],
  exports: [TranslatePipe]
})
export class TranslatePipeModule {

}
